/**
 * 사내 제품(크롤러·AXIOM) 쿼리 키.
 *
 * 캠페인 홍보 대상물(ScenarioProduct)과 다른 엔티티다 — 그쪽은 시나리오 상세에 실려 오므로
 * 자기 루트 키가 없다.
 *
 * 회귀 가드: `__tests__/queryKeyLiteralGate.test.ts` (새 루트는 팩토리부터).
 */
import { defineQueryKeys } from '@/shared/lib/queryKeys';

export const productKeys = defineQueryKeys('products', (all) => ({
  /**
   * 내 팀 제품 목록 — 서버가 소속 팀으로 좁혀 준다.
   *
   * `includeInactive` 를 키에 싣는다. 내린 제품이 섞인 목록과 안 섞인 목록은 서로 다른 응답이라
   * 같은 키를 쓰면 관리 패널에서 "내린 제품 보기"를 켠 결과가 퀘스트 창 스파인 캐시를 덮는다.
   * 기본(false)은 루트 그 자체를 키로 써서 기존 무효화 경로를 그대로 탄다.
   */
  list: (includeInactive = false) =>
    includeInactive ? ([...all, 'includeInactive'] as const) : ([...all] as const),
  detail: (id: string) => [...all, id] as const,
}));
